import { connect } from 'react-redux';
import { getSelectOptions } from 'src/reducers/selectOptions';
import SelectBoxBonusNames from '../components/SelectBoxBonusNames';

const mapStateToProps = state => ({
  bonusNames: getSelectOptions(state, 'bonusNames')
});
export default connect(mapStateToProps)(SelectBoxBonusNames);
